import React from "react";

import StatusTabTable, {
  statusValidationSchema as schema
} from "../../../SystemThreshold/StatusTab";

import "./style.scss";

export const statusValidationSchema = schema("Status");

function StatusTab({ readOnly }) {
  return (
    <div className="kpi-config__form__status-tab">
      <StatusTabTable name="Status" readOnly={readOnly} />
    </div>
  );
}

export default StatusTab;
